import { defineMessages } from 'react-intl';

export const notificationTypeMessages = {
  canReceiveOpportunityEmails: defineMessages({
    title: {
      id: 'notifications.opportunity-emails.title',
      defaultMessage: 'Spot adjustment opportunities',
    },
    description: {
      id: 'notifications.opportunity-emails.description',
      defaultMessage: 'Suggestions to optimize schedule and fill',
    },
  }),
  canReceiveReservationNotificationEmails: defineMessages({
    title: {
      id: 'notifications.reservations.title',
      defaultMessage: 'Reservations and cancellations',
    },
    description: {
      id: 'notifications.reservations.description',
      defaultMessage: 'Be notified for every ClassPass reservation and cancellation.',
    },
  }),
  canReceiveRosterNotifications: defineMessages({
    title: {
      id: 'notifications.roster.title',
      defaultMessage: 'Daily rosters',
    },
    description: {
      id: 'notifications.roster.description',
      defaultMessage: 'Class roster report delivered each morning',
    },
  }),
  canReceiveSms: defineMessages({
    title: {
      id: 'notifications.sms.title',
      defaultMessage: 'SMS notifications',
    },
    description: {
      id: 'notifications.sms.description',
      defaultMessage: 'Select the location for which you would like to receive these texts:',
    },
    disclaimer: {
      id: 'notifications.sms.disclaimer',
      defaultMessage:
        'I agree to receive text messages about my ClassPass reservations and cancellations to the phone number below. Standard message and data rates may apply. Manage your opt-out preferences here or reply STOP to any text.',
    },
  }),
  canReceiveChangelogEmails: defineMessages({
    title: {
      id: 'notifications.changelog.title',
      defaultMessage: 'Daily change log',
    },
    description: {
      id: 'notifications.changelog.description',
      defaultMessage: 'Summary of schedule changes',
    },
  }),
  canReceiveDigestEmails: defineMessages({
    title: {
      id: 'notifications.digest.title',
      defaultMessage: 'Weekly digest',
    },
    description: {
      id: 'notifications.digest.description',
      defaultMessage: 'Weekly performance summary and insights',
    },
  }),
  canReceiveNoPricingOptionReservationEmails: defineMessages({
    title: {
      id: 'notifications.can-receive-pricing-option-reservation-emails.title',
      defaultMessage: 'Integration notices',
    },
    description: {
      id: 'notifications.can-receive-pricing-option-reservation-emails.description',
      defaultMessage: 'Reservation statuses',
    },
  }),
  canReceiveAttendanceInquiryEmails: defineMessages({
    title: {
      id: 'notifications.attendance-inquiry-emails.title',
      defaultMessage: 'Reservation management',
    },
    description: {
      id: 'notifications.attendance-inquiry-emails.description',
      defaultMessage: 'Attendance, classes, and approval requests',
    },
  }),
};

const messages = defineMessages({
  phoneNumberInput: {
    id: 'notifications.phone-number-input',
    defaultMessage: 'Phone number',
  },
  title: {
    id: 'notifications.title',
    defaultMessage: 'Notifications',
  },
  submit: {
    id: 'notifications.submit',
    defaultMessage: 'Save',
  },
  venueEmailsTitle: {
    id: 'notifications.venue-emails.title',
    defaultMessage: 'Venue emails',
  },
  venueEmailsSelectAll: {
    id: 'notifications.venue-emails.select-all',
    defaultMessage: 'Select all',
  },
  someVenuesOptedIn: {
    id: 'notifications.venue-emails.some-venues-opted-in',
    defaultMessage: 'Some venues are opted in',
  },
  smsVenueSelectLabel: {
    id: 'notifications.sms.venue-select-label',
    defaultMessage: 'Select venues for SMS notifications',
  },
  categoryOperational: {
    id: 'notifications.category.operational',
    defaultMessage: 'Operational notifications',
  },
  categoryPerformance: {
    id: 'notifications.category.performance',
    defaultMessage: 'Performance optimization',
  },
  allVenues: {
    id: 'notifications.sms.all-venues',
    defaultMessage: 'All venues',
  },
  selectVenue: {
    id: 'notifications.sms.select-venue',
    defaultMessage: 'Select a location',
  },
  tag: {
    id: 'notifications.opportunity-emails.tag',
    defaultMessage: '{venueName}{venueSubtitle, select, undefined {} other { ({venueSubtitle})}}',
  },
  loadError: {
    id: 'notifications.load.error',
    defaultMessage: 'There was a problem loading your notification settings.',
  },
  requiredTag: {
    id: 'notifications.required-tag',
    defaultMessage: 'Please select at least one venue.',
  },
  updateSuccess: {
    id: 'notifications.update.success',
    defaultMessage: 'Your notification settings have been updated.',
  },
  updateError: {
    id: 'notifications.update.error',
    defaultMessage: 'There was problem updating your notification settings.',
  },
  marketingTitle: {
    id: 'notifications.marketing.title',
    defaultMessage: 'Marketing emails',
  },
  marketingCallout: {
    id: 'notifications.marketing.callout',
    defaultMessage:
      'Marketing emails from ClassPass include product newsletters and announcements, partner program news, and offers about ClassPass services. You can opt in or out at any time from this page; your choice will not affect your access to ClassPass services.',
  },
  marketingToggleLabel: {
    id: 'notifications.marketing.toggle-label',
    defaultMessage: 'Opt-in',
  },
  marketingSubscribeSuccess: {
    id: 'notifications.marketing.subscribe-success',
    defaultMessage: "You've been subscribed to marketing emails.",
  },
  marketingUnsubscribeSuccess: {
    id: 'notifications.marketing.unsubscribe-success',
    defaultMessage: "You've been unsubscribed from marketing emails.",
  },
  marketingUpdateError: {
    id: 'notifications.marketing.update-error',
    defaultMessage: 'There was a problem updating your marketing email preferences.',
  },
  orderNotificationsTitle: {
    id: 'notifications.order-notifications.title',
    defaultMessage: 'New order alerts',
  },
  orderNotificationsSoundTitle: {
    id: 'notifications.order-notifications.sound-title',
    defaultMessage: 'Notification sound',
  },
  orderNotificationsSoundDescription: {
    id: 'notifications.order-notifications.sound-description',
    defaultMessage: 'Play a sound when new orders arrive on the Orders page. Applies to this browser only.',
  },
  orderNotificationsBrowserTitle: {
    id: 'notifications.order-notifications.browser-title',
    defaultMessage: 'Browser notifications',
  },
  orderNotificationsBrowserDescription: {
    id: 'notifications.order-notifications.browser-description',
    defaultMessage: 'Get notified by your browser when new orders arrive while you are in another tab.',
  },
  orderNotificationsPermissionDenied: {
    id: 'notifications.order-notifications.permission-denied',
    defaultMessage:
      'Notifications are blocked for this site. To enable them, allow notifications in your browser settings and reload the page.',
  },
});

export default messages;
